import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import LoyaltyCircle from '../../../../components/LoyaltyCircle';
import { ResponsiveImage } from 'dabbl-react-components';
import ShopriteCard from '../../../../components/ShopriteCard';
import {DOWNTIMEDOLLARS_LOGO, PROGRESS_COLOR} from "../../../../retailerValues";

class DowntimeDollarsBar extends Component {

  static propTypes = {
    // Redux - required
    bufferAmount: PropTypes.number.isRequired,
    goalAmount: PropTypes.number.isRequired
  }

  render() {
    const {
      bufferAmount
    } = this.props;

    const percentToGoal  = bufferAmount / 9 * 100;
    const finalBufferAmt = bufferAmount.toFixed(2)

    return (
      <div className="DowntimeDollarsBar">

        {/* NOTE: for loyalty circle - does not work if nested; needs .DowntimeDollarsBar width */}
        <div className="DowntimeDollarsBar_circle_shadow"></div>

        <div className="DowntimeDollarsBar_container">
          <Container>
            <Row>

              {/* Title */}
              <Col xs={4}>
                  <ResponsiveImage
                    className="DowntimeDollarsBar_logo_img"
                    src={DOWNTIMEDOLLARS_LOGO}
                    alt="Downtime Dollars"
                  />
              </Col>

              {/* Loyalty Circle */}
              <Col xs={4}>
                <div className="DowntimeDollarsBar_circle_background">
                  <LoyaltyCircle
                    className="DowntimeDollarsBar_loyaltyCircle"
                    percentFull={percentToGoal}
                    text={`$${finalBufferAmt}`}
                    color={PROGRESS_COLOR}
                  />
                </div>
              </Col>
            </Row>
          </Container>

        </div>
      </div>
    );
  }
}

export default DowntimeDollarsBar;



// WEBPACK FOOTER //
// ./src/pages/Campaigns/containers/DowntimeDollarsBar/DowntimeDollarsBar.js